// extracted by mini-css-extract-plugin
module.exports = {"highlighted":"style_highlighted__3-7nS"};